// removed by extract-text-webpack-plugin
module.exports = {"mobileBreakPoint":"992px","fadeIn":"src-templates----Tour-module---fadeIn---1imZ0","fadeInUp":"src-templates----Tour-module---fadeInUp---3oqEF","fadeInUpCenter":"src-templates----Tour-module---fadeInUpCenter---11k0z","fadeInUpSmall":"src-templates----Tour-module---fadeInUpSmall---2rkNX","textCoverIn":"src-templates----Tour-module---textCoverIn---3iHzh","textCoverOut":"src-templates----Tour-module---textCoverOut---33vHc"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/Tour.module.scss
// module id = 870
// module chunks = 151087471038741